export var matchUnit = function (unitData, unit) {
    return (unitData.id.toLocaleLowerCase() === (unit === null || unit === void 0 ? void 0 : unit.toLocaleLowerCase()) ||
        (unitData.alias &&
            unitData.alias.map(function (alias) { return alias.toLocaleLowerCase(); }).includes(unit)));
};
// 由于 bytes 的单位中会有 b 和 B ，所以对别名进行判断时不能转换为小写
export var matchDataUnit = function (unitData, unit) {
    return (unitData.id.toLocaleLowerCase() === (unit === null || unit === void 0 ? void 0 : unit.toLocaleLowerCase()) ||
        (unitData.alias && unitData.alias.includes(unit)));
};
//# sourceMappingURL=util.js.map